class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.megaMenu = this.querySelector('.mega-menu');
    this.content = this.megaMenu?.querySelector('.mega-menu__content');
    this.hideTimeout = null;
    this.HIDE_DELAY = 150; // milliseconds delay before hiding
    
    if (this.megaMenu && this.content) {
      this.megaMenu.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.megaMenu.addEventListener('mouseleave', this.onMouseLeave.bind(this));
      this.megaMenu.addEventListener('focusin', this.onFocusIn.bind(this));
      this.megaMenu.addEventListener('focusout', this.onFocusOut.bind(this));
    }
  }

  onMouseEnter() {
    // Clear any pending hide timeout
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }
    
    // Remove the delayed-hide class if it exists
    this.megaMenu.classList.remove('mega-menu--delayed-hide');
    
    if (!this.header) return;
    this.header.preventHide = true;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onMouseLeave() {
    // Add class to keep menu visible temporarily
    this.megaMenu.classList.add('mega-menu--delayed-hide');
    
    // Set timeout to remove the class after delay
    this.hideTimeout = setTimeout(() => {
      this.megaMenu.classList.remove('mega-menu--delayed-hide');
      this.hideTimeout = null;
    }, this.HIDE_DELAY);
    
    if (!this.header) return;
    this.header.preventHide = false;
  }

  onFocusIn() {
    // Clear any pending hide timeout
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }
    this.megaMenu.classList.remove('mega-menu--delayed-hide');
    
    if (!this.header) return;
    this.header.preventHide = true;
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement) && this.header) {
        this.header.preventHide = false;
      }
    });
  }
}

customElements.define('header-menu', HeaderMenu);
